import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/security")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/security" });
	},
});
